if (!customElements.get('good-night-countdown')) {
  customElements.define('good-night-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.hidden = false;
      this.display = this.querySelector('[data-countdown]');
      this.fallback = this.querySelector('[data-fallback]');
      this.expired = this.querySelector('[data-expired]');
      this.units = this.querySelectorAll('[data-unit]');
      this.numbers = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-${unit}]`));
      this.error = this.querySelector('[data-date-error]');
      this.display.hidden = true;
      this.fallback.hidden = false;
      this.target = this.parseTarget();
      if (this.error) this.error.hidden = Number.isFinite(this.target);
      if (!Number.isFinite(this.target)) return;

      this.fallback.hidden = true;
      this.display.hidden = false;
      this.expired.hidden = true;
      this.units.forEach(unit => { unit.hidden = false; });
      if (this.update()) this.interval = window.setInterval(() => this.update(), 1000);
    }

    parseTarget() {
      const date = (this.dataset.endDate || '').trim();
      const time = (this.dataset.endTime || '').trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(time)) return NaN;
      const [year, month, day] = date.split('-').map(Number);
      const calendar = new Date(`${date}T00:00:00Z`);
      // Date.parse can normalize impossible calendar dates (for example February 30).
      if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() + 1 !== month || calendar.getUTCDate() !== day) return NaN;
      return Date.parse(`${date}T${time.length === 5 ? `${time}:00` : time}+03:00`);
    }

    update() {
      const remaining = this.target - Date.now();
      if (remaining <= 0) {
        this.stop();
        this.units.forEach(unit => { unit.hidden = true; });
        this.expired.hidden = false;
        // Keep the section selectable in the theme editor even when it has expired.
        this.hidden = this.dataset.hideExpired === 'true' && !window.Shopify?.designMode;
        return false;
      }

      const seconds = Math.floor(remaining / 1000);
      const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
      this.numbers.forEach((element, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (element.textContent !== value) element.textContent = value;
      });
      return true;
    }

    stop() {
      window.clearInterval(this.interval);
      this.interval = null;
    }

    disconnectedCallback() {
      this.stop();
    }
  });
}
